import React from 'react';
import styled from 'styled-components';
import Link from '@material-ui/core/Link';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core/styles';
import { requirePropFactory, Typography } from '@material-ui/core';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { BodyParent, BodyChildren } from './animation/variants';

import './styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '375px',
      marginTop: '-40px',
      marginBottom: '70px',
      flexDirection: 'column !important',
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '950px',
      marginBottom: '100px',
      alignItems: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1085px',
    },
  },
  laptopBooks: {
    [theme.breakpoints.down('sm')]: {
      width: '375px',
      height: '380px',
    },
    [theme.breakpoints.up('md')]: {
      width: '435px',
      height: '440px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '545px',
      height: '555px',
    },
  },
  title: {
    color: theme.palette.secondary.main,
  },
  description: {
    maxWidth: '950px',
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '31px',
    letterSpacing: '-0.04em',
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  contact: {
    color: theme.palette.secondary.light,
    fontSize: 24,
    fontStyle: 'normal',
    lineHeight: '31px',
    letterSpacing: '-0.04em',
  },
  carouselWrapper: {
    width: '100%',
    background: theme.palette.secondary.dark,
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.25) 0 0 14px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '370px',
      padding: '20px',
      maxWidth: '375px',
      marginTop: '10px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '40px',
      marginLeft: '20px',
      maxWidth: '425px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '40px',
      marginLeft: '20px',
      maxWidth: '520px',
    },
  },
  arrows: {
    [theme.breakpoints.down('sm')]: {
      margin: '0 5px',
    },
  },
}));

const Wrapper = styled.div`
  display: flex;
`;

const Body = styled.div`
  margin-left: 10px;
`;

const TechLeaders = () => {
  const [ref, inView] = useInView({
    rootMargin: '-100px 100px',
    triggerOnce: true,
    width: '100%',
  });

  const classes = useStyles();

  const carouselSettings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <motion.div
      ref={ref}
      variants={BodyParent}
      initial="initial"
      animate={inView ? 'enter' : 'initial'}>
      <Wrapper className={classes.root}>
        <Body>
          <motion.div variants={BodyChildren}>
            <Typography variant="h2" className={classes.title}>
              Inspiring Technology Leaders
            </Typography>
          </motion.div>
          <motion.p className={classes.description} variants={BodyChildren}>
            Experience a weekend of incredible speakers, mentors, and judges.
            Build your skills and learn about the future of technology.
            <br />
            <br />
            Interested in supporting the event? We’d love to get in touch!
          </motion.p>
          <motion.div variants={BodyChildren}>
            <Link href="mailto:hello@hackwestern.com">
              <b className={classes.contact}>hello@hackwestern.com</b>
            </Link>
          </motion.div>
        </Body>
        <motion.div className={classes.carouselWrapper} variants={BodyChildren}>
          <Slider {...carouselSettings}>
            <div>
              <img
                src={require('./assets/people/arina-2.jpg')}
                alt="arina-scotiabank"
              />
            </div>
            <div>
              <img
                src={require('./assets/people/gordon-sandford.jpg')}
                alt="gordon-sandford"
              />
            </div>
            <div>
              <img
                src={require('./assets/people/janet-bannister.jpg')}
                alt="janet-bannister"
              />
            </div>
            <div>
              <img
                src={require('./assets/people/keith-2.jpg')}
                alt="keith-horwood"
              />
            </div>
            <div>
              <img
                src={require('./assets/people/steve-dengler.jpg')}
                alt="steve-dengler"
              />
            </div>
          </Slider>
        </motion.div>
      </Wrapper>
    </motion.div>
  );
};

export default TechLeaders;
